<template>
  <div class="precision-form-item__account-name">{{ accountName }}</div>
  <div>
    <component :is="instance.getFormAmount1()" :instance @ready="handleReady" />
  </div>
</template>

<script setup lang="ts">
import { TransactionClass } from '@types'
import { computed } from 'vue'

import { ASSET_FIELD } from '@/const'

import { useAssetsBunchStore } from '@/store/assets/bunch'

type Props = {
  instance: TransactionClass
  index: number
}

const props = defineProps<Props>()

const assetsBunchStore = useAssetsBunchStore()

const accountId = computed(() => props.instance.entry1().value?.account_id || '')
const accountName = computed(() => assetsBunchStore.getElementById(accountId.value)?.field<string>(ASSET_FIELD.NAME).value)

const handleReady = (el: HTMLInputElement) => {
  if (props.index !== 0) return
  el.focus()
}
</script>

<style scoped>
.precision-form-item__account-name {
  @apply flex items-center;
  @apply text-sm font-medium;
  @apply truncate;
}
</style>
